module.exports = "<span jf-tooltip-on-overflow>\n\t<i class=\"icon\"\n\t   ng-class=\"{'icon-lock':$ctrl.version.state !== $ctrl.DISTRIBUTION_CONSTANTS.BUNDLE_VERSION_STATES.OPEN,\n\t\t\t\t  'icon-unlock':$ctrl.version.state === $ctrl.DISTRIBUTION_CONSTANTS.BUNDLE_VERSION_STATES.OPEN}\">\n\t</i>{{$ctrl.DISTRIBUTION_CONSTANTS.BUNDLE_VERSION_STATE_LABELS[$ctrl.version.state]}}\n</span>"


//////////////////
// WEBPACK FOOTER
// ./modules/distribution/modules/distribution/components/bundle/version/components/versionState/version.state.view.html
// module id = 508
// module chunks = 7